module.exports = __webpack_public_path__ + "img/temp-banner-faq.484fc819.png";